import { useMemo } from 'react';
import { useFeatureFlags } from '../../../utils/featureFlags';
import type { AutomationPageV2StoreProviderProps } from './context.types';
import { AutomationPageV2StoreContext } from './contextStore';
import { AutomationPageV2Store } from './store';

export function AutomationPageV2StoreProvider({
	children,
}: AutomationPageV2StoreProviderProps) {
	const { automationAiGeneration } = useFeatureFlags();
	const store = useMemo(
		() => new AutomationPageV2Store(automationAiGeneration),
		[automationAiGeneration]
	);

	return (
		<AutomationPageV2StoreContext.Provider value={store}>
			{children}
		</AutomationPageV2StoreContext.Provider>
	);
}
